import { Group, Text } from "@mantine/core";
import { IconExclamationCircle } from "@tabler/icons-react";
import React from "react";

import { CUSTOMER_DROPPED_MESSAGE } from "./customerDroppedNotice";
import styles from "./CustomerDroppedNotification.module.css";

export const CustomerDroppedNotification = () => {
    return (
        <Group className={styles.notificationBanner}>
            <IconExclamationCircle size={15} className={styles.notificationIcon} />
            <Text className={styles.notificationText} size="xs">
                {CUSTOMER_DROPPED_MESSAGE}
            </Text>
        </Group>
    );
};
